import ForwardToInboxOutlinedIcon from '@mui/icons-material/ForwardToInboxOutlined';
import { Badge, Box, IconButton, Tooltip } from '@mui/material';
import InterruptionCreateButton from '../interruprions/shared/InterruptionCreateButton';
import SheduleFocusTimeButton from '../interruprions/shared/SheduleFocusTimeButton';

type AvailabilityActionButtonsProps = {
  interruptionsCount: number;
  onCreateInterruption: () => void;
  onExpandInterruptions: () => void;
  onOpenFocusTime: () => void;
};

const ACTIONS_SX = {
  display: 'flex',
  alignItems: 'center',
  gap: 1,
} as const;

const EXPAND_BUTTON_SX = {
  position: 'relative',
  width: 36,
  height: 36,
  border: '1px solid',
  borderColor: 'primary.main',
  borderRadius: '50%',
  color: 'primary.main',
  fontSize: 14,
  fontWeight: 600,
  lineHeight: 1,
} as const;

const BADGE_SX = {
  '& .MuiBadge-badge': {
    minWidth: 12,
    height: 12,
    border: '1px solid',
    borderColor: 'background.default',
    borderRadius: '50%',
    right: -4,
    top: 10,
  },
} as const;

const AvailabilityActionButtons = ({
  interruptionsCount,
  onCreateInterruption,
  onExpandInterruptions,
  onOpenFocusTime,
}: AvailabilityActionButtonsProps) => (
  <Box sx={ACTIONS_SX}>
    <Tooltip title="Expand interruptions">
      <IconButton
        aria-label={`Expand interruptions. ${interruptionsCount} active interruptions`}
        sx={EXPAND_BUTTON_SX}
        onClick={onExpandInterruptions}
      >
        <Badge
          color="error"
          anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
          invisible={interruptionsCount === 0}
          sx={BADGE_SX}
          variant="dot"
        >
          <ForwardToInboxOutlinedIcon fontSize="small" />
        </Badge>
      </IconButton>
    </Tooltip>

    <InterruptionCreateButton onClick={onCreateInterruption} />
    <SheduleFocusTimeButton onClick={onOpenFocusTime} />
  </Box>
);

export default AvailabilityActionButtons;
